var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sk-btn sk-btn--white system-log-btn",on:{"click":_vm.openSystemLogModal}},[_vm._v("\n  "+_vm._s(_vm.$gettext('System log'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }